import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt, FaCheck } from 'react-icons/fa'
import { FiRefreshCw } from 'react-icons/fi'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import Input from '../../../shared/components/form/input'
import Radio from '../../../shared/components/form/Radio'
import api from '../../../utils/api'

import EditStockItem from '../EditStockItem'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'

const MOVEMENT_TYPE_OPTIONS = [
    { value: 'entrada', label: 'Entrada' },
    { value: 'saida', label: 'Saída' },
    { value: 'ajuste', label: 'Ajuste' },
]

function ListStockItemRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [modalEditItem, setModalEditItem] = useState(false)
    const [itemId, setItemId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [itemName, setItemName] = useState("")

    const [movementItem, setMovementItem] = useState(null)
    const [movementForm, setMovementForm] = useState({ type: 'entrada', quantity: '', reason: '' })

    async function deleteItem(id) {
        let msgType = 'success'
        const data = await api.delete(`/stock/general/delete/${id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    function openMovement(item) {
        setMovementItem(item)
        setMovementForm({ type: 'entrada', quantity: '', reason: '' })
    }

    async function submitMovement() {
        let msgType = 'success'
        const data = await api.patch(`/stock/general/movement/${movementItem._id}`, movementForm, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => response.data).catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            setMovementItem(null)
            handleOnSuccess()
        }
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => {
                const low = item.currentQuantity <= item.minQuantity
                return (
                    <div key={item._id} className='pg-item'>
                        <div className='pg-item-main'>
                            <div className="stock-row-text">
                                <div className="stock-row-header">
                                    <span className='pg-item-name'>{item.name}</span>
                                    {item.category && <span className="stock-row-material-tag">{item.category}</span>}
                                    {low && <span className="sg-low-tag">{item.currentQuantity <= 0 ? 'Zerado' : 'Abaixo do mínimo'}</span>}
                                </div>
                                {item.minQuantity > 0 && (
                                    <div className="stock-row-links">
                                        <span className="stock-row-link-item">Mínimo: {item.minQuantity} {item.unit?.value}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="stock-row-saldo-col">
                            <span className="stock-row-saldo-caption">Saldo</span>
                            <span className={`stock-row-saldo-value${low ? ' sg-saldo-low' : ''}`}>{item.currentQuantity} {item.unit?.label || item.unit?.value}</span>
                        </div>

                        <div className='shd-row-box-item-action'>
                            {myPermissionEdit &&
                                <FiRefreshCw className='shd-icon-row-edit' title='Movimentar' onClick={() => openMovement(item)} />
                            }
                            {myPermissionEdit &&
                                <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setItemId(item._id); setModalEditItem(true) }} />
                            }
                            {myPermissionDelete &&
                                <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setItemId(item._id); setItemName(item.name) }} />
                            }
                        </div>
                    </div>
                )
            })
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditItem}
                changeStatus={setModalEditItem}
                w={82}
                content={
                    <EditStockItem id={itemId} handleOnSuccess={() => { setModalEditItem(false); handleOnSuccess() }} btCancelAction={() => setModalEditItem(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteItem(itemId)}
                message="Deseja realmente excluir esse item de estoque?"
                itemName={itemName}
            />

            <Modal
                modalStatus={!!movementItem}
                changeStatus={() => setMovementItem(null)}
                w={40}
                content={
                    movementItem && (
                        <div className="sg-movement">
                            <p className="sg-movement-title">Movimentar — {movementItem.name}</p>
                            <span className="sg-movement-title-accent" />
                            <p className="sg-movement-current">Saldo atual: <strong>{movementItem.currentQuantity} {movementItem.unit?.label || movementItem.unit?.value}</strong></p>

                            <Radio
                                options={MOVEMENT_TYPE_OPTIONS}
                                name="type"
                                value={movementForm.type}
                                defaultValue="entrada"
                                handleOnChange={(name, value) => setMovementForm({ ...movementForm, type: value })}
                            />

                            <Input
                                text={movementForm.type === 'ajuste' ? 'Quantidade (use negativo pra reduzir)' : 'Quantidade'}
                                type="number"
                                name="quantity"
                                placeholder="0.00"
                                handleOnChange={(e) => setMovementForm({ ...movementForm, quantity: e.target.value })}
                                value={movementForm.quantity}
                            />
                            <Input
                                text="Motivo"
                                type="text"
                                name="reason"
                                placeholder="Ex.: compra, uso, perda, contagem"
                                handleOnChange={(e) => setMovementForm({ ...movementForm, reason: e.target.value })}
                                value={movementForm.reason}
                            />

                            <button type="button" className="sg-movement-confirm" onClick={submitMovement}>
                                <FaCheck size={13} /> Confirmar
                            </button>
                        </div>
                    )
                }
            />

        </div>
    )
}

export default ListStockItemRow
